module.exports = __webpack_public_path__ + "img/05.077ba1a5.png";